import * as axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};
export const getCustomers = (token) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/customers`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});

export const getCustomer = (token, customerId) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/customers/${customerId}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const createCustomer = (token, body) => axios.post(`${VUE_APP_API_URL}/api/v1/admin/customers`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const updateCustomer = (token, id, body) => axios.put(`${VUE_APP_API_URL}/api/v1/admin/customers/${id}`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const deleteCustomer = (token, id) => axios.delete(`${VUE_APP_API_URL}/api/v1/admin/customers/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
